module.exports = __webpack_public_path__ + "static/img/4494_phase_function_Paper_Points.92aba0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4494_phase_function_Paper_Points.png
// module id = XllY
// module chunks = 0